module.exports = __webpack_public_path__ + "static/media/pexels-photo-2280547.2fb6c3dc.jpeg";